import React from 'react'
import ReactLoading from 'react-loading'

import styles from './index.module.css'

export default function Loading() {
  return (
    <div className={styles.cntr}>
      <ReactLoading type='bars' color='#124EE6' height={48} width={48} />
    </div>
  )
}
